import type { FC, ReactNode } from "react";
import { Icon } from "../Icon/Icon";
import type { IconNames } from "../Icon/svg";
import classes from "./Token.module.scss";

export interface TokenProps {
	title: string;
	name: IconNames;
	children: ReactNode;
}

export interface TokenComponent extends FC<TokenProps> {}

export const Token: TokenComponent = ({ title, name, children }) => {
	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<h4 className={classes.title}>{title}</h4>
				<Icon className={classes.icon} name={name} />
				<span className={classes.text}>{children}</span>
			</div>
		</div>
	);
};
